<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show">
                <div class="row" style="margin:20px">
                    <v-carousel height="550">
                        <v-carousel-item v-for="(item, i) in listadofoto" :key="i" :src="item" contain
                            max-height="450px" reverse-transition="fade-transition" transition="fade-transition"
                            title="item.titulo">
                            <v-row>
                                <div style="margin:20px">
                                    <font color="#000000" face="Arial" size="3">{{
                                        item.titulo
                                    }}</font>
                                </div>
                            </v-row>
                        </v-carousel-item>
                    </v-carousel>
                </div>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import router from "../../../src/router/index";
import axios from "../../../src/axios-auth";

export default {

    data: (vm) => ({
        valid: false,
        lazy: false,
        listadofoto: [],
        visible: true,
        foto: "",
        path: "",
    }),

    computed: {
        show: {
            get() {
                this.buscarFotos();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarInforme();
                    //   console.log("cerrado");
                    //   this.$refs.form.resetValidation();
                    //   document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarInforme() {
            this.listadofoto = [];
        },
        buscarFotos() {
            this.vaciarInforme();

            let self = this;
            axios
                .get("/Images/GetImagesByFolder?", {
                    params: {
                        folder: "simulacro",
                    },
                })
                .then((response) => {
                    self.listadofoto = response.data;
                    console.log("FOTOS: ", self.listadofoto);
                })
                .catch((error) => {
                    self.listadofoto = [];
                    console.log(error);
                });
        },
    },
};
</script>